import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=997dc9ce&scoped=true"
import script from "./Matrix.vue?vue&type=script&lang=js"
export * from "./Matrix.vue?vue&type=script&lang=js"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=997dc9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997dc9ce",
  null
  
)

export default component.exports